import { i18nMark } from 'lingui-react';

const messages = {
  make: i18nMark('Make'),
  model: i18nMark('Model'),
  unit: i18nMark('Unit'),
  year: i18nMark('Year'),
};

export default messages;



// WEBPACK FOOTER //
// ./compositions/ServiceRequestOverview/messages.js